import { createActions } from '../utils/reduxUtils';
export var setZipCode = createActions('SET_ZIP_CODE');
export var getServicedZipCodes = createActions('GET_SERVICED_ZIP_CODES');
export var resetServicedZipCodes = createActions('RESET_SERVICED_ZIP_CODES');
export var removeZipCode = createActions('REMOVE_ZIP_CODE');
export var setPromoCode = createActions('SET_PROMO_CODE');
export var removePromoCode = createActions('REMOVE_PROMO_CODE');
export var subscribeEmailOnNotifications = createActions('SUBSCRIBE_EMAIL');
export var firstPickupWrongZipCode = createActions('FIRST_PICKUP_WRONG_ZIP_CODE');
export var getHolidays = createActions('GET_HOLIDAYS');
export var getHolidaysAndSetToStore = createActions('GET_HOLIDAYS_AND_SET');
export var addDriverContact = createActions('ADD_DRIVER_CONTACT');
export var getJobs = createActions('GET_JOBS');
// Partners actions
export var schedulePartnerPickup = createActions('SCHEDULE_PARTNER_PICKUP');
export var getPartner = createActions('GET_PARTNER');
export var getPartnersForSavers = createActions('GET_PARTNER_FOR_SAVERS');
export var addPartnerContact = createActions('ADD_PARTNER_CONTACT');
export var createAdditionalPartnerPackages = createActions('CREATE_ADDITIONAL_PARTNER_PACKAGES');
export var togglePartner = createActions('TOGGLE_PARTNER');
export var createPartner = createActions('CREATE_PARTNER');
export var updatePartner = createActions('UPDATE_PARTNER');
export var createPartnerAttribute = createActions('CREATE_PARTNER_ATTRIBUTE');
export var createPartnerAttributeLocally = createActions('CREATE_PARTNER_ATTRIBUTE_LOCALLY');
export var updatePartnerAttribute = createActions('UPDATE_PARTNER_ATTRIBUTE');
export var deletePartnerAttribute = createActions('DELETE_PARTNER_ATTRIBUTE');
export var createPartnerPrice = createActions('CREATE_PARTNER_PRICE');
export var createUserForPartner = createActions('CREATE_USER_FOR_PARTNER');
export var deleteUserFromPartner = createActions('DELETE_USER_FROM_PARTNER');
export var updatePartnerPrice = createActions('UPDATE_PARTNER_PRICE');
export var deletePartnerPrice = createActions('DELETE_PARTNER_PRICE');
export var getReturnReasons = createActions('GET_RETURN_REASONS');
export var createPartnerDestination = createActions('CREATE_PARTNER_DESTINATION');
export var deletePartnerDestination = createActions('DELETE_PARTNER_DESTINATION');
// User actions
export var signUp = createActions('SIGN_UP');
export var forgotPassword = createActions('FORGOT_PASSWORD');
export var updatePassword = createActions('UPDATE_PASSWORD');
export var logout = createActions('LOGOUT');
export var getUser = createActions('GET_USER');
export var getPaymentMethods = createActions('GET_PAYMENT_METHODS');
export var updateUser = createActions('UPDATE_USER');
export var myAccountUpdatePassword = createActions('MY_ACCOUNT_UPDATE_PASSWORD');
export var sendEmailVerification = createActions('SEND_EMAIL_VARIFICATION');
export var checkEmail = createActions('CHECK_EMAIL');
export var getUserById = createActions('GET_USER_BY_ID');
export var addUserToDriver = createActions('ADD_USER_TO_DRIVER');
export var getConsolidatedUserById = createActions('GET_CONSOLIDATED_USER_BY_ID');
export var getUserRecentTrips = createActions('GET_USER_RECENT_TRIPS');
// Files actions
export var createUploadUrl = createActions('CREATE_UPLOAD_URL');
export var signUrl = createActions('SIGN_URL');
export var signUrls = createActions('SIGN_URLS');
// Pickup actions
export var schedulePickup = createActions('SCHEDULE_PICKUP');
export var firstPickupCreationStart = createActions('FIRST_PICKUP_CREATION_START');
export var savePickupSelectedDate = createActions('SAVE_PICKUP_SELECTED_DATE');
export var getTrips = createActions('GET_TRIPS');
export var getTripsPage = createActions('GET_TRIPS_PAGE');
export var getAuditsPage = createActions('GET_AUDITS_PAGE');
export var getTrip = createActions('GET_TRIP');
export var getDriverTripByTripId = createActions('GET_DRIVER_TRIP_BY_TRIP_ID');
export var getDriverTrips = createActions('GET_DRIVER_TRIPS');
export var deletePickup = createActions('DELETE_PICKUP');
export var getDeliveriesByPhone = createActions('GET_DELIVERIES_BY_PHONE');
export var submitTrip = createActions('SUBMIT_TRIP');
export var onTripUpdate = createActions('ON_TRIP_UPDATE');
export var onTripAuditUpdate = createActions('ON_TRIP_AUDIT_UPDATE');
export var addTripToAudits = createActions('ADD_TRIP_TO_AUDITS');
export var batchUpdateTrips = createActions('BATCH_TRIPS_UPDATE');
export var confirmTrip = createActions('CONFIRM_TRIP');
export var getTripETAValue = createActions('GET_TRIP_ETA_VALUE');
export var refreshTripEATValue = createActions('REFRESH_TRIP_EAT_VALUE');
export var getEATRecencyThreshold = createActions('GET_EAT_RECENCY_THRESHOLD');
export var updateTripCSAT = createActions('UPDATE_TRIP_CSAT');
// Consolidations actions
export var getConsolidations = createActions('GET_CONSOLIDATIONS');
export var getContainers = createActions('GET_CONTAINERS');
export var resetConsolidations = createActions('RESET_CONSOLIDATIONS');
export var getPackageConsolidation = createActions('GET_PACKAGE_CONSOLIDATION');
export var setConsolidationTableColumnWidth = createActions('SET_CONSOLIDATION_TABLE_COLUMN_WIDTH');
export var setOutboundConsolidationTableColumnWidth = createActions('SET_OUTBOUND_CONSOLIDATION_TABLE_COLUMN_WIDTH');
export var createConsolidation = createActions('CREATE_CONSOLIDATION');
export var createOutboundConsolidation = createActions('CREATE_OUTBOUND_CONSOLIDATION');
export var updateConsolidation = createActions('UPDATE_CONSOLIDATION');
export var createConsolidationPackage = createActions('CREATE_CONSOLIDATION_PACKAGE');
export var deleteConsolidationPackage = createActions('DELETE_CONSOLIDATION_PACKAGE');
export var getConsolidationPackages = createActions('GET_CONSOLIDATION_PACKAGES');
export var createConsolidationAddress = createActions('CREATE_CONSOLIDATION_ADDRESS');
export var deleteConsolidationAddress = createActions('DELETE_CONSOLIDATION_ADDRESS');
export var getPackingSlipByConsolidationId = createActions('GET_PACKING_SLIP_BY_CONSOLIDATION_ID');
export var registerConsolidationScan = createActions('REGISTER_CONSOLIDATION_SCAN');
export var getConsolidationById = createActions('GET_CONSOLIDATION_BY_ID');
export var setCurrentSidebarConsolidation = createActions('SET_CURRENT_SIDEBAR_CONSOLIDATION');
export var clearCurrentSidebarConsolidation = createActions('CLEAR_CURRENT_SIDEBAR_CONSOLIDATION');
// Address actions
export var saveAddressId = createActions('SAVE_ADDRESS_ID');
export var removeAddress = createActions('REMOVE_ADDRESS');
export var removeAddressById = createActions('REMOVE_ADDRESS_BY_ID');
export var updateAddress = createActions('UPDATE_ADDRESS');
export var createAddress = createActions('CREATE_ADDRESS');
export var createUserAddress = createActions('CREATE_USER_ADDRESS');
export var getAddressValidationFeedback = createActions('GET_ADDRESS_VALIDATION_FEEDBACK');
export var resetAddressValidationFeedback = createActions('RESET_ADDRESS_VALIDATION_FEEDBACK');
export var addPartnerDestination = createActions('ADD_PARTNER_DESTINATION');
export var upsertPreviousAddressTrip = createActions('UPSERT_PREVIOUS_ADDRESS_TRIP');
export var upsertPreviousAddressPackage = createActions('UPSERT_PREVIOUS_ADDRESS_PACKAGE');
// Payment actions
export var applyPromoCode = createActions('APPLY_PROMO_CODE');
export var applyPartnerPromoCode = createActions('APPLY_PARTNER_PROMO_CODE');
export var getPaymentIntent = createActions('GET_PAYMENT_INTENT');
export var getPartnerPaymentIntent = createActions('GET_PARTNER_PAYMENT_INTENT');
export var makePayment = createActions('MAKE_PAYMENT');
export var createSubscription = createActions('CREATE_SUBSCRIPTION');
export var createSubscriptionAndPay = createActions('CREATE_SUBSCRIPTION_AND_PAY');
// Login actions
export var login = createActions('LOGIN');
export var refresh = createActions('REFRESH');
export var googleLogin = createActions('GOOGLE_LOGIN');
// Admin actions
export var getHubs = createActions('GET_HUBS');
export var getDashboardData = createActions('GET_DASHBOARD_DATA');
export var getUsersByDate = createActions('GET_USERS_BY_DATE');
export var getUsers = createActions('GET_USERS');
export var getUsersForSavers = createActions('GET_USERS_FOR_SAVERS');
export var updateTrip = createActions('UPDATE_TRIP');
export var processScan = createActions('PROCESS_SCAN');
export var deleteScan = createActions('DELETE_SCAN');
export var processQRCodeScan = createActions('PROCESS_QR_CODE_SCAN');
export var processPolybagScan = createActions('PROCESS_POLYBAG_SCAN');
export var getCarriers = createActions('GET_CARRIERS');
export var getRetailers = createActions('GET_RETAILERS');
export var createRetailer = createActions('CREATE_RETAILER');
export var toggleZipCode = createActions('TOGGLE_ZIP_CODE');
export var includeZipCodes = createActions('INCLUDE_ZIP_CODES');
export var batchUpdateServicedZipCodes = createActions('BATCH_UPDATE_SERVICED_ZIP_CODES');
export var sendComms = createActions('SEND_COMMS');
export var getMissingPackages = createActions('GET_MISSING_PACKAGES');
export var getPartners = createActions('GET_PARTNERS');
export var createPartnerUser = createActions('CREATE_PARTNER_USER');
export var getTripSummary = createActions('GET_TRIP_SUMMARY');
export var getPackageSummary = createActions('GET_PACKAGE_SUMMARY');
export var getOnfleetWorkers = createActions('GET_ONFLEET_WORKERS');
export var getOnfleetWorkersForRoutes = createActions('GET_ONFLEET_WORKERS_FOR_ROUTES');
export var clearOnfleetWorkersForRoutes = createActions('CLEAR_ONFLEET_WORKERS_FOR_ROUTES');
export var setIsAdmin = createActions('SET_IS_ADMIN');
export var setUserRole = createActions('SET_USER_ROLE');
export var getUserRole = createActions('GET_USER_ROLE');
export var updateUserRole = createActions('UPDATE_USER_ROLE');
export var removeUserHub = createActions('REMOVE_USER_HUB');
export var addUserToHub = createActions('ADD_USER_TO_HUB');
export var addUserToHubAtStore = createActions('ADD_USER_TO_HUB_AT_STORE');
export var setPackageTableColumnWidth = createActions('SET_PACKAGE_TABLE_COLUMN_WIDTH');
export var setSaverTableColumnWidth = createActions('SET_SAVER_TABLE_COLUMN_WIDTH');
export var setTripTableColumnWidth = createActions('SET_TRIP_TABLE_COLUMN_WIDTH');
export var scanBarcode = createActions('SCAN_BARCODE');
export var getPackageServiceTypes = createActions('GET_PACKAGES_SERVICE_TYPES');
export var asyncJobStatusUpdate = createActions('ASYNC_JOB_STATUS_UPDATE');
export var executeRoutePricing = createActions('EXECUTE_ROUTE_PRICING');
export var createPolybags = createActions('CREATE_POLYBAGS');
export var createTripAudit = createActions('CREATE_TRIP_AUDIT');
export var assignUserToTripAudit = createActions('ASSIGN_USER_TO_TRIP_AUDIT');
export var completeTripAudit = createActions('COMPLETE_TRIP_AUDIT');
export var setBadCompletionNotes = createActions('SET_BAD_COMPLETION_NOTES');
export var completeSaverReviewForTripAudit = createActions('COMPLETE_SAVER_REVIEW_FOR_TRIP_AUDIT');
export var assignSaverToTripAudit = createActions('ASSIGN_SAVER_TO_TRIP_AUDIT');
export var getDummyDriversByHubId = createActions('GET_DUMMY_DRIVERS_BY_HUB_ID');
export var getDrivers = createActions('GET_DRIVERS');
// Zones actions
export var createZone = createActions('CREATE_ZONE');
export var deleteZone = createActions('DELETE_ZONE');
export var updateZone = createActions('UPDATE_ZONE');
// Package actions
export var updatePackage = createActions('UPDATE_PACKAGE');
export var createPackage = createActions('CREATE_PACKAGE');
export var addNewPackage = createActions('ADD_NEW_PACKAGE');
export var getPackages = createActions('GET_PACKAGES');
export var getPublicPackages = createActions('GET_PUBLIC_PACKAGES');
export var getPackagesByIdentifier = createActions('GET_PACKAGES_BY_IDENTIFIER');
export var getPackagesByIdentifierAdmin = createActions('GET_PACKAGES_BY_IDENTIFIER_ADMIN');
export var getPackage = createActions('GET_PACKAGE');
export var getPackagesByCarrier = createActions('GET_PACKAGES_BY_CARRIER');
export var createTripMedia = createActions('CREATE_TRIP_MEDIA');
export var createTrip = createActions('CREATE_TRIP');
export var deleteTripMedia = createActions('DELETE_TRIP_MEDIA');
export var deletePackage = createActions('DELETE_PACKAGE');
export var clearPackageTrackingId = createActions('CLEAR_PACKAGE_TRACKING_ID');
export var reschedule = createActions('RESCHEDULE');
export var packageTrackingList = createActions('GET_PACKAGE_TRACKING_LIST');
export var packageTrackingListExpanded = createActions('GET_PACKAGE_TRACKING_LIST_EXPANDED');
export var clearRequiresAgeVerification = createActions('CLEAR_REQUIRES_AGE_VERIFICATION');
export var updateTripPackagesAddressId = createActions('UPDATE_TRIP_PACKAGES_ADDRESS_ID');
export var splitPackageByAddressId = createActions('SPLIT_PACKAGE_BY_ADDRESS_ID');
export var clearPackageTrackingList = createActions('CLEAR_PACKAGE_TRACKING_LIST');
export var onPackageUpdate = createActions('ON_PACKAGE_UPDATE');
export var clearCurrentPackage = createActions('CLEAR_CURRENT_PACKAGE');
// Manifest actions
export var getManifest = createActions('GET_MANIFEST');
export var importManifest = createActions('IMPORT_MANIFEST');
export var getManifests = createActions('GET_MANIFESTS');
export var getFiles = createActions('GET_FILES');
export var getFile = createActions('GET_FILE');
export var updateManifestReportErrors = createActions('UPDATE_MANIFEST_REPORT_ERRORS');
// Operations actions
export var operationReports = createActions('OPERATION_REPORTS');
export var operationReportsCount = createActions('OPERATION_REPORTS_COUNT');
export var operationReport = createActions('OPERATION_REPORT');
export var operationReportUpdate = createActions('OPERATION_REPORT_UPDATE');
export var setOperationReports = createActions('SET_OPERATION_REPORTS');
export var resetOperationsReports = createActions('RESET_OPERATION_REPORTS');
// Web Socket actions
export var manifestReportUpdate = createActions('MANIFEST_REPORT_UPDATE');
// SnackBars
export var addSnackBar = createActions('ADD_SNACKBAR');
export var removeNotificationItem = createActions('REMOVE_NOTIFICATION_ITEM');
// Blog actions
export var getBlogs = createActions('GET_BLOGS');
export var getBlog = createActions('GET_BLOG');
// Order actions
export var createOrderWithItems = createActions('CREATE_ORDER_WITH_ITEMS');
export var getOrderItems = createActions('GET_ORDER_ITEMS');
// RN actions
export var addReturnItems = createActions('ADD_RETURN_ITEMS');
// RMS actions
export var getShopifyPartnerShops = createActions('GET_SHOPIFY_PARTNER_SHOPS');
export var togglePartnerShop = createActions('TOGGLE_PARTNER_SHOP');
export var getPartnerShop = createActions('GET_PARTNER_SHOP');
export var storeItemsToReturn = createActions('STORE_ITEMS_TO_RETURN');
// Notifications actions
export var notificationReport = createActions('NOTIFICATION_REPORT');
// Locations actions
export var updateLocation = createActions('UPDATE_LOCATION');
export var createLocation = createActions('CREATE_LOCATION');
export var getLocations = createActions('GET_LOCATIONS');
export var getLocation = createActions('GET_LOCATION');
export var resetLocations = createActions('RESET_LOCATIONS');
// Routes actions
export var getRoutes = createActions('GET_ROUTES');
export var getRoute = createActions('GET_ROUTE');
export var modifyRoute = createActions('MODIFY_ROUTE');
export var createDriverReliability = createActions('CREATE_DRIVER_RELIABILITY');
export var clearRoute = createActions('CLEAR_ROUTE');
export var setRoutesTableColumnWidth = createActions('SET_ROUTES_TABLE_COLUMN_WIDTH');
export var createRouteEntitlements = createActions('CREATE_ROUTE_ENTITLEMENTS');
//# sourceMappingURL=actionTypes.js.map